const actions = {
  setup() {},
  async getData({ dispatch }) {
    dispatch('messages/hideLoadingMessage', { componentName: 'custom-analytics', text: 'Complete' }, { root: true })
  },
}

export default actions
